import React, { useState, useEffect } from 'react';
import { Select, Avatar, Badge } from 'antd';
import _ from 'lodash';
import { Link, Redirect } from "react-router-dom";
import RadioBox, { RadioGroup } from '../../../../components/uielements/radio';
import { siteConfig } from "../../../../settings";
import { notification } from '../../../../components/index';
import Button from "../../../../components/uielements/button";
import CommunitySwitcherWrapper from './communitySwitcher.style';
import AuthService from './auth.service';
import authAction from "../../../../redux/auth/actions";
import { connect } from "react-redux";

const { login } = authAction;
const DEBUG = siteConfig.DEBUG

function communitySwitcher() {
    const accessToken = localStorage.getItem('access_token');
    const cuurentCommunityID = localStorage.getItem('communityID');
    const [accessTokenData, setAccessTokenData] = useState(null);
    const [communityList, setCommunityList] = useState(JSON.parse(localStorage.getItem('communityList') || []));
    const [selectedCommunity, setSelectedCommunity] = useState('');
    const [isLoadingCommunitySelected, setIsLoadingCommunitySelected] = useState(false);
    const [userInfo, setUserInfo] = useState("");
    const [communityAclList, setCommunityAclList] = useState([]);
    const [redirect, setRedirect] = useState(false);
    const [communityUserNotificationCount, setCommunityUserNotificationCount] = useState([]);

    // useEffect(()=>{
    //   //GET USER COMMUNITY NOTIFICATION COUNT
    //   AuthService.getCommunityUserNotificationCount().then((res)=>{
    //     DEBUG && console.log(`getCommunityUserNotificationCount: ${JSON.stringify(res)}`);
    //     setCommunityUserNotificationCount(res.items)
    //   })
    // },[])

    const radioStyle = {
        display: 'flex',
        alignItems: 'center',
        height: '90px',
        paddingLeft: '10px',
        marginBottom: '10px',
        backgroundColor: '#ebebeb',
        borderRadius: '10px',
        border: 'solid 1px #ebebeb',
        width: '100%',
    };

    /***** LOGIN TO COMMUNITY FUNCTION *****/
    const loginToCommunity = (userCommunity) => {
        DEBUG && console.log('LOGIN TO COMMUNITY FUNCTION');
        DEBUG && console.log(`loginToCommunity: ${userCommunity}`)

        setIsLoadingCommunitySelected(true);

        //GET USER COMMUNITY
        AuthService.getUserInfo().then((res) => {
            DEBUG && console.log(`getUserCommunity: ${JSON.stringify(res)}`);
            if (res.errorMessage) {
                DEBUG && console.log(`getUserCommunity_ERROR`)
                notification('error', res.errorMessage);
            }
            setUserInfo(res)

            //STORE TO LOCALSTORAGE
            localStorage.setItem('userID', res.userID);
            localStorage.setItem('userFirstname', res.profile.firstname)
            localStorage.setItem('userLastname', res.profile.lastname)
            localStorage.setItem('userImageUrl', res.profile.imageUrl);
            localStorage.setItem('userDisplayStatus', userCommunity.displayCommunityRole);
            localStorage.setItem('communityID', userCommunity.communityID);
            localStorage.setItem('communityName', userCommunity.communityName);

            //UPDATE USER PREFERENCE
            AuthService.updateUserPreference(userCommunity.communityID).then((res) => {
                DEBUG && console.log(`updateUserPreference: ${JSON.stringify(res)}`);
                if (res.errorMessage) {
                    DEBUG && console.log(`getUserCommunity_ERROR`)
                    notification('error', res.errorMessage);
                }

                //GET COMMUNITY FEATURE LIST
                AuthService.getUserAcl(userCommunity.communityID).then((res) => {
                    DEBUG && console.log(`getUserAcl_items: ${JSON.stringify(res.items)}`);
                    if (res.errorMessage) {
                        DEBUG && console.log(`getUserAcl_ERROR`)
                        notification('error', res.errorMessage);
                    }
                    setCommunityAclList(res.items);

                    //GET COMMUNITY INFO
                    AuthService.getCommunityInfo(userCommunity.communityID).then((res) => {
                        DEBUG && console.log(`getCommunityInfo_items: ${JSON.stringify(res)}`);
                        if (res.errorMessage) {
                            DEBUG && console.log(`getCommunityInfo_ERROR`)
                            notification('error', res.errorMessage);
                        }
                        localStorage.setItem('communityInfo', JSON.stringify(res));
                        localStorage.setItem('communityType', res.communityInfo.communityType);
                        window.location.reload();
                        // setRedirect(true)

                    })
                   
                })
                    .catch(err => {
                        notification('error', `LOGIN ERROR: ${err}`);
                        DEBUG && console.log(`LOGIN ERROR: : ${err}`);
                        setAccessTokenData(null);
                        setIsLoadingCommunitySelected(false);
                        localStorage.removeItem('access_token');
                    });

            });
        });
    }


    if (redirect) return <Redirect to="/dashboard/" />;;
    return (
        <CommunitySwitcherWrapper>
            {/* selectedCommunity: {JSON.stringify(selectedCommunity)} <br/> */}
            {/* communityUserNotificationCount: {JSON.stringify(communityUserNotificationCount)} <br/>
            communityList: {JSON.stringify(communityList)} */}
            {/* communityListWithCount: {JSON.stringify(_.merge(communityList,communityUserNotificationCount))} */}
            <div>
                <RadioGroup
                    style={{ width: '100%' }}
                    onChange={e => setSelectedCommunity(e.target.value)}
                    value={selectedCommunity}
                >
                    
                    {/* {_.merge(communityList,communityUserNotificationCount).map(item => */}
                    {communityList.map(item =>
                        <RadioBox
                            key={item.communityID}
                            style={radioStyle}
                            value={item}
                            disabled={item.isResident && !item.isCommittee || communityList.length === 1 || item.communityID === cuurentCommunityID} //||!item.isCommittee || !item.isPMC || !item.isJPM || !item.isAdvisor
                        >
                            <span style={{ display: 'flex', flexDirection: 'row' }}>
                                <span>
                                    <Avatar size={64} src={item.imageUrl} />
                                </span>
                                <span style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ display: 'inline', fontFamily: 'Kanit', fontSize: '22px', paddingLeft: '10px', overflow: 'hidden' }}>
                                            {item.communityName} {item.communityID === cuurentCommunityID ? ' (ปัจจุบัน)': null}{/* <Badge count={item.totalNotificationCount} /> */}
                                    </span>
                                    <span style={{ display: 'inline', fontFamily: 'Kanit', fontSize: '14px', paddingLeft: '10px', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                        ({item.displayCommunityRole})
                             </span>
                                </span>
                            </span>
                        </RadioBox>
                    )}
                </RadioGroup>
                <Button
                    block
                    type="primary"
                    disabled={selectedCommunity === '' || communityList.length === 1}
                    onClick={() => loginToCommunity(selectedCommunity)}
                    loading={isLoadingCommunitySelected}
                >
                    เปลี่ยนชุมชน
                </Button>
            </div>
        </CommunitySwitcherWrapper>
    );
};

export default connect(
    state => ({
      isLoggedIn: state.Auth.idToken !== null ? true : false
    }),
    { login }
  )(communitySwitcher);